import React from "react";

import CountryLevelBreadcrumbs from "./components/CountryLevelBreadcrumbs";
import WorldLevelBreadcrumbs from "./components/WorldLevelBreadcrumbs";

import StateLevelBreadcrumbs from "./components/StateLevelBreadcrumbs";
import CountyLevelBreadcrumbs from "./components/CountyLevelBreadcrumbs";



import useDistancingArgs from "./useDistancingArgs";

export default function DistancingHomeTopBar() {
  const { level, country, state, county } = useDistancingArgs();

  switch (level) {
    case "country":
      return <CountryLevelBreadcrumbs country={country} />;
    case "state":
      return <StateLevelBreadcrumbs country={country} state={state} />;
    case "county":
      return <CountyLevelBreadcrumbs country={country} state={state} county={county}/>;
    default:
      return <WorldLevelBreadcrumbs />;
  }
}
